import { Popper } from '@components/display/poppers';
import { InputField } from '@components/utility/inputs';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Button from '@mui/material/Button/Button';
import { ClickAwayListener } from '@mui/material/ClickAwayListener/ClickAwayListener';
import Paper from '@mui/material/Paper/Paper';
import { getYoutubeId } from '@utils/common';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { RefObject, useRef, useState } from 'react';

const MenuExternalVideo = () => {
    const editor = useRichTextEditorContext();
    const [open, setOpen] = useState(false);
    const [youtubeUrl, setYoutubeUrl] = useState({
        value: '',
        error: false,
    });

    const ref = useRef<HTMLButtonElement>(null);

    return (
        <>
            <MenuButton
                buttonRef={ref as RefObject<HTMLButtonElement>}
                onClick={() => setOpen(true)}
                tooltipLabel="Insert youtube video"
                disabled={!editor?.isEditable}
            >
                <PlayCircleIcon />
            </MenuButton>
            <Popper open={open} anchorEl={ref.current} placement="bottom" transition className="z-10">
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <Paper className="p-3 min-w-[500px]">
                        <InputField
                            label="YouTube URL"
                            fullWidth
                            onChange={(e) =>
                                setYoutubeUrl({
                                    value: e.target.value,
                                    error: getYoutubeId(e.target.value) === null,
                                })
                            }
                            error={youtubeUrl.error}
                            helperText={youtubeUrl.error ? 'Please enter a valid YouTube URL' : ''}
                        />
                        <Button
                            className="mt-2 block ml-auto"
                            disabled={youtubeUrl.error || youtubeUrl.value === ''}
                            onClick={() => {
                                editor?.commands.setExternalVideo({ src: youtubeUrl.value });
                                setOpen(false);
                                setYoutubeUrl({ value: '', error: false });
                            }}
                        >
                            INSERT
                        </Button>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export { MenuExternalVideo };
